const signatureStatus = Object.freeze({
  Signed: 1,
  PendingSignature: 2,
});

export { signatureStatus };
